module.exports = __webpack_public_path__ + "img/poi-marker-red.b3e305cc.png";